<div class="highlight-wrapper" *ngIf="text">
    <div class="container">
        <div class="row">
            <div class="col-12 text-left">
                {{text}}
            </div>
        </div>
    </div>
</div>
